import React from 'react'
import { HiArrowRight } from "react-icons/hi";
import { useTheme } from '../theme/ThemeContext';

const Card = ({title,des,icon}) => {
  const {darkTheme} = useTheme();
  return (
<div className={darkTheme ? "w-full px-12 h-80 py-10 rounded-lg shadow-shadowTwo flex items-center bg-gradient-to-r from-bodyColor to-[gray] group hover:bg-gradient-to-b hover:from-bodyColor hover:to-[gray] transition-colors duration-100 group" :
 "w-full px-12 h-80 py-10 rounded-lg shadow-shadowTwo flex items-center bg-gradient-to-r from-grayBodyColor to-[gray] group hover:bg-gradient-to-b hover:from-grayBodyColor hover:to-[gray] transition-colors duration-100 group"}>
      <div className="h-72 overflow-y-hidden">
        <div className="flex h-full flex-col gap-10 translate-y-16 group-hover:translate-y-0 transition-transform duration-500">
          <div className="w-10 h-8 flex flex-col justify-between">
        
            {icon ? (
              <span className="text-5xl text-designColor">{icon}</span>
            ) : (
              <>
                <span className="w-full h-[2px] rounded-lg bg-designColor inline-flex"></span>
                <span className="w-full h-[2px] rounded-lg bg-designColor inline-flex"></span>
                <span className="w-full h-[2px] rounded-lg bg-designColor inline-flex"></span>
                <span className="w-full h-[2px] rounded-lg bg-designColor inline-flex"></span>
              </>
            )}
          </div>
          <div className="flex flex-col gap-6">
            <h2 className={darkTheme?"text-black md:text-2xl font-titleFont font-bold text-black-300"
            :"text-black md:text-2xl font-titleFont font-bold text-black-300"}>
              {title}
            </h2>
            <p className={darkTheme?"base":"text-black"}>{des}</p>
            <span className="text-2xl text-designColor">
              <HiArrowRight />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card